import { useEffect } from 'react';

interface PixelProps {
  pixelId: string;
  marketingCookies: boolean;
}

const TiktokPixel = ({ pixelId, marketingCookies }: PixelProps) => {
  useEffect(() => {
    try {
      // validate pixel id is alphanumeric and at least 10 characters long
      if (pixelId?.match(/^[A-Z0-9]{10,}$/) && marketingCookies) {
        const script = document.createElement('script');
        script.id = 'tiktok-pixel';
        script.async = true;
        script.innerHTML = `
      (function(){try{
          !function (w, d, t) {
            w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
            ttq.load('${pixelId}');
            ttq.page(); // initial page view event
          }(window, document, 'ttq');
      }catch{/*swallow exception*/}})();
    `;
        document.head.appendChild(script);
      }
    } catch {
      /*swallow exception*/
    }
  }, [pixelId, marketingCookies]);

  return null;
};

export default TiktokPixel;
